/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_TitleInputs */

const es_admin_billing_batch_title = /** @type {(inputs: Admin_Billing_Batch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagar por adelantado`)
};

const en_admin_billing_batch_title = /** @type {(inputs: Admin_Billing_Batch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay in advance`)
};

/**
* | output |
* | --- |
* | "Pay in advance" |
*
* @param {Admin_Billing_Batch_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_title = /** @type {((inputs?: Admin_Billing_Batch_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_title(inputs)
	return en_admin_billing_batch_title(inputs)
});
export { admin_billing_batch_title as "admin.billing.batch.title" }